// 9x7 color palette shared by the desktop and mobile color charts.
// One hue family per row, roughly ordered from dark to light, following the color wheel.
const COLOR_PALETTE: string[][] = [
    // Neutrals and deep reds
    ['#FFFFFF', '#999999', '#444444', '#000000', '#800000', '#8B0000', '#B2001A'],
    // Reds
    ['#A52A2A', '#A3412D', '#CD5C5C', '#FF0000', '#E5232E', '#EA5045', '#FF4500'],
    // Oranges and peaches
    ['#C24718', '#FF8C00', '#FF7F50', '#FFA07A', '#F7AC6F', '#FFDAB9', '#E6D2B5'],
    // Browns
    ['#5C3317', '#8B4513', '#B8860B', '#A0522D', '#AB7942', '#C29E88', '#DEB887'],
    // Yellows
    ['#DAA130', '#FFD700', '#FFFF00', '#FFFAAA', '#FFFACD', '#D9C479', '#687131'],
    // Greens
    ['#556B2F', '#228B22', '#008B45', '#98FB98', '#B2D2B2', '#66CDAA', '#008080'],
    // Teals and cyans
    ['#004040', '#2F4F4F', '#5F9EA0', '#ACC5C6', '#87CEEB', '#00BFFF', '#007EA7'],
    // Blues
    ['#000080', '#0000CD', '#1E90FF', '#244D96', '#8098CB', '#E6E6FA', '#800080'],
    // Purples and pinks
    ['#9400D3', '#BAA0C1', '#AF7292', '#D376A7', '#FF1493', '#E72A55', '#FFC0CB'],
];

export { COLOR_PALETTE };
